// TraditionalInstructionsBanner.jsx
import React from 'react';
import { LiaDiceSolid } from 'react-icons/lia';

/* ───────────────────────── Banner (match MixerInstructionsBanner) ───────────────────────── */
const S = {
  container: {
    maxWidth: 680,
    width: '94%',
    margin: '.75rem auto 0',
    padding: '0 12px',
    boxSizing: 'border-box',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },

  // Header row (kept, styled like mixer)
  dividerRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '.75rem',
    color: '#6b7280',
    fontWeight: 700,
    letterSpacing: '.06em',
    textTransform: 'uppercase',
    marginBottom: 16,
  },
  dividerLine: { flex: 1, height: 1, backgroundColor: '#eee' },
  dividerText: {
    margin: '0 0.75rem',
    background: '#fafafa',
    border: 'solid 1px #fff',
    padding: '6px 12px',
    borderRadius: 100,
  },

  // TicketCard-style banner
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 8px',
    margin: '8px 0px 18px',
    background: '#fff',
    backdropFilter: 'blur(8px)',
    borderRadius: 12,
    border: '1px solid #eee',
  },
  bannerIcon: {
    width: 38,
    height: 38,
    borderRadius: 10,
    flexShrink: 0,
    display: 'grid',
    placeItems: 'center',
    background: '#fff',
    border: '0.5px solid #eee',
  },
  iconTile: {
    width: 26,
    height: 26,
    borderRadius: 8,
    display: 'grid',
    placeItems: 'center',
  },
  bannerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    marginLeft: 6,
    flexWrap: 'nowrap',
    minWidth: 0,
    gap: 8,
  },
  bannerTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: -4,
    flex: 1,
    minWidth: 0,
  },
  bannerHeader: {
    fontSize: 12.5,
    fontWeight: 800,
    color: '#111',
    lineHeight: 1.25,
    marginBottom: 1,
    letterSpacing: 0.1,
    textTransform: 'none',
  },
  bannerText: {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1.3,
    color: '#222',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    marginRight: 20,
  },
  primaryBtn: {
    backgroundColor: '#fff',
    color: '#111827',
    padding: '8px 12px',
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 700,
    border: '1px solid #e5e7eb',
    cursor: 'pointer',
    flexShrink: 0,
  },
};

export default function TraditionalInstructionsBanner({ onReview }) {
  const headerText    = 'Quick guide';
  const secondaryLine = 'A short tour of how this works.';

  return (
    <div style={S.container}>
      {/* divider row */}
      <div style={S.dividerRow}>
        <div style={S.dividerLine} />
        <div style={S.dividerText}>Overview</div>
        <div style={S.dividerLine} />
      </div>

      {/* ticketcard-style banner */}
      <div style={S.banner} role="region" aria-label="Event quick guide">
        {/* left icon tile */}
        <div style={S.bannerIcon} aria-hidden>
          <div style={S.iconTile}>
            <LiaDiceSolid style={{ fontSize: 18, color: '#0B0B0B' }} />
          </div>
        </div>

        {/* center content */}
        <div style={S.bannerContent}>
          <div style={S.bannerTextWrapper}>
            <div style={S.bannerHeader} title={headerText}>{headerText}</div>
            <span style={S.bannerText} title={secondaryLine}>{secondaryLine}</span>
          </div>

          {/* right cta */}
          <button
            type="button"
            style={S.primaryBtn}
            onClick={onReview}
            aria-label="Open quick guide"
          >
            Review
          </button>
        </div>
      </div>
    </div>
  );
}
